var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfertRapport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.056,
    height: 81.961,
    viewBox: "0 0 142.056 81.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0082de;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.434 -9.019)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M59.948,90.98H32.737a8.313,8.313,0,0,1-8.3-8.3V17.625a1,1,0,0,1,2,0V82.678a6.309,6.309,0,0,0,6.3,6.3H59.948a6.309,6.309,0,0,0,6.3-6.3V54.315a1,1,0,0,1,2,0V82.677A8.313,8.313,0,0,1,59.948,90.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.251,39.169a1,1,0,0,1-1-1V17.322a6.31,6.31,0,0,0-6.3-6.3H32.737a6.31,6.31,0,0,0-6.3,6.3,1,1,0,0,1-2,0,8.313,8.313,0,0,1,8.3-8.3H59.948a8.313,8.313,0,0,1,8.3,8.3V38.169A1,1,0,0,1,67.251,39.169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.665,87.027a5.456,5.456,0,1,1,5.455-5.456A5.463,5.463,0,0,1,46.665,87.027Zm0-8.912a3.456,3.456,0,1,0,3.455,3.456A3.46,3.46,0,0,0,46.665,78.115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M159.73,11.33H86.39a6.773,6.773,0,0,0-6.77,6.76V34.42h2.06V18.09a4.718,4.718,0,0,1,4.71-4.71h73.34a4.716,4.716,0,0,1,4.7,4.71V68.44a4.709,4.709,0,0,1-4.7,4.71H86.39a4.712,4.712,0,0,1-4.71-4.71V54.01H79.62V68.44a6.773,6.773,0,0,0,6.77,6.76h27.05V88.39H100.71a1.03,1.03,0,0,0,0,2.06H145.4a1.03,1.03,0,1,0,0-2.06H132.68V75.2h27.05a6.764,6.764,0,0,0,6.76-6.76V18.09A6.764,6.764,0,0,0,159.73,11.33ZM130.62,88.39H115.49V75.2h15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M81.68,22.28V38.127a1.029,1.029,0,0,1-2.058,0V22.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M79.622,63.875V54.028a1.029,1.029,0,0,1,2.058,0v9.847"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.6,45.262H48.052a1,1,0,0,0,0,2H49.6a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M97.656,40.1a1,1,0,1,0-1.392,1.436l3.85,3.731H52.608a1,1,0,0,0,0,2h47.506l-3.849,3.73a1,1,0,1,0,1.39,1.436l6.366-6.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.928,12.985H43.379a1,1,0,0,0,0,2h6.549a1,1,0,0,0,0-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfertRapport);
export default __webpack_public_path__ + "static/media/transfert-rapport.c07b618a5680aa9e87724f5fd0785d7f.svg";
export { ForwardRef as ReactComponent };